export default {"src":"/_next/static/media/1000_gradient.d2f35f24.svg","height":58,"width":123,"blurWidth":0,"blurHeight":0};